// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__XpXu5","filesListContainer":"PosDisputesFiles_filesListContainer__2y5bx","filesButton":"PosDisputesFiles_filesButton__2AYUo"};